module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/statement-f9546e26d0ee1a4c58ea37203f921cd9.png";